const listenerBenefits = [
  {
    icon: 'ri-search-line',
    title: 'Descubrir Estaciones',
    description: 'Encuentra nuevas radios por categoría, ubicación o frecuencia. Explora un ecosistema completo de contenido.',
  },
  {
    icon: 'ri-headphone-line',
    title: 'Escuchar en Vivo',
    description: 'Disfruta de transmisiones en vivo con calidad de audio profesional desde cualquier dispositivo.',
  },
  {
    icon: 'ri-chat-smile-3-line',
    title: 'Chatear con la Cabina',
    description: 'Envía mensajes, saludos y canciones en tiempo real a tus locutores favoritos mientras transmiten.',
  },
  {
    icon: 'ri-trophy-line',
    title: 'Competir y Rankear',
    description: 'Participa en rankings, gana insignias, acumula puntos RFW y competí con otros oyentes de la comunidad.',
  },
  {
    icon: 'ri-group-line',
    title: 'Unirte a Clubes',
    description: 'Forma parte de clubes de fans, participa en retos, eventos exclusivos y construí comunidad con otros oyentes.',
  },
  {
    icon: 'ri-notification-3-line',
    title: 'Seguir y Conectar',
    description: 'Seguí a tus radios, locutores y programas favoritos. Recibí notificaciones y nunca te pierdas nada.',
  },
];

export default function BenefitsListeners() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="lg:w-2/5">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">
              <i className="ri-user-line text-xs"></i>
              Para Oyentes
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-foreground-950 tracking-tight mb-4">
              Los oyentes no solo escuchan,{' '}
              <span className="text-primary-600">son protagonistas</span>
            </h2>
            <p className="text-foreground-500 text-base leading-relaxed mb-6">
              En RFW cada oyente tiene su perfil social, gana niveles, desbloquea insignias y compite en rankings. Escuchar radio ya no es solo oír: es participar, competir y pertenecer a una comunidad.
            </p>
            <a
              href="#explorar"
              onClick={(e) => {
                e.preventDefault();
                const el = document.querySelector('#explorar');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 hover:bg-accent-600 text-background-50 font-semibold rounded-xl transition-all duration-200 cursor-pointer text-sm shadow-lg shadow-accent-500/20"
            >
              Empezar a Descubrir
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="lg:w-3/5 grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
            {listenerBenefits.map((benefit) => (
              <div
                key={benefit.title}
                className="flex items-start gap-4 bg-background-50 rounded-xl p-4 border border-background-200/70 hover:border-accent-200 transition-all duration-300"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 shrink-0">
                  <i className={`${benefit.icon} text-base`}></i>
                </div>
                <div>
                  <h3 className="font-semibold text-foreground-950 text-sm mb-1">{benefit.title}</h3>
                  <p className="text-foreground-500 text-xs leading-relaxed">{benefit.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}